import { render } from "./NavMenu.vue?vue&type=template&id=6d341532"
const script = {}

import exportComponent from "/srv/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__